module.exports = __webpack_public_path__ + "pic_bizny_web_04@1x.png?acebc1c90fddfe94e41e4505a7241a2f";